import { type JSX, type MouseEvent } from 'react';
import useClickedProductsStore from '@/stores/ClickedProductsStore';
import useCurationStore from '@/stores/CurationStore';
import type { Product } from '@/types/Product.types';
import styles from './AddButton.module.css';

const AddButton = ({ product }: { product: Product }): JSX.Element => {
  const { isProductSelected, addProduct, removeProduct } = useCurationStore();
  const { clickedProducts, handleProductClick } = useClickedProductsStore();
  const isAdded = isProductSelected(product.id);

  const handleButtonClick = (e: MouseEvent): void => {
    e.preventDefault();
    e.stopPropagation();
    if (isAdded) {
      removeProduct(product.id);
      // Also remove from clicked products if it exists there
      if (clickedProducts.has(product.id)) {
        handleProductClick(product.id);
      }
    } else {
      addProduct(product);
    }
  };

  return (
    <button
      className={`${styles.addButton} ${isAdded ? styles.added : ''}`}
      onClick={handleButtonClick}
    >
      {isAdded ? '-' : '+'}
    </button>
  );
};

export default AddButton;
